import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

/** @jsx jsx */
import { useEffect, useState } from 'react';
import { jsx } from '@emotion/core';
import PersonIcon from '@atlaskit/icon/glyph/person';
import ShipIcon from '@atlaskit/icon/glyph/ship';
import { background, N50 } from '@atlaskit/theme/colors';
import { AVATAR_RADIUS, AVATAR_SIZES } from './constants';

var AvatarImage = function AvatarImage(_ref) {
  var _ref$alt = _ref.alt,
      alt = _ref$alt === void 0 ? '' : _ref$alt,
      src = _ref.src,
      appearance = _ref.appearance,
      size = _ref.size,
      testId = _ref.testId;

  var _useState = useState('initial'),
      _useState2 = _slicedToArray(_useState, 2),
      phase = _useState2[0],
      setPhase = _useState2[1];

  var borderRadius = appearance === 'circle' ? '50%' : "".concat(AVATAR_RADIUS[size], "px");
  useEffect(function () {
    // check whether there was a problem loading the image
    // if handleLoadError is called we show the default avatar
    var img;

    if (src) {
      setPhase('loading');
      img = new Image();

      img.onload = function () {
        return setPhase('loaded');
      };

      img.onerror = function () {
        return setPhase('error');
      };

      img.src = src;
    }

    return function () {
      if (img) {
        img.onload = function () {};

        img.onerror = function () {};
      }
    };
  }, [src]);

  if (phase === 'loading' || phase === 'error' || !src) {
    return jsx("span", {
      css: {
        backgroundColor: N50,
        width: '100%',
        height: '100%',
        display: 'block',
        '& svg': {
          height: "".concat(AVATAR_SIZES[size], "px"),
          width: "".concat(AVATAR_SIZES[size], "px")
        }
      }
    }, appearance === 'circle' ? jsx(PersonIcon, {
      label: alt,
      primaryColor: background(),
      secondaryColor: N50,
      testId: testId && "".concat(testId, "--person")
    }) : jsx(ShipIcon, {
      label: alt,
      primaryColor: background(),
      secondaryColor: N50,
      testId: testId && "".concat(testId, "--ship")
    }));
  }

  return jsx("span", {
    css: {
      backgroundColor: 'transparent',
      backgroundImage: "url(".concat(src, ")"),
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover',
      borderRadius: borderRadius,
      display: 'flex',
      flex: '1 1 100%',
      height: '100%',
      width: '100%'
    },
    role: "img",
    "aria-label": alt,
    "data-testid": testId && "".concat(testId, "--image")
  });
};

export default AvatarImage;